import { useEffect, useRef } from 'react';
import Quill from 'quill';

const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline'],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link', 'clean'],
];

/** Thin wrapper over Quill 2.x (no react-quill dependency). */
export function QuillEditor({
  value,
  onChange,
}: {
  value: string;
  onChange: (html: string) => void;
}) {
  const holderRef = useRef<HTMLDivElement>(null);
  const quillRef = useRef<Quill | null>(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    if (!holderRef.current || quillRef.current) return;
    const q = new Quill(holderRef.current, {
      theme: 'snow',
      modules: { toolbar: TOOLBAR },
    });
    quillRef.current = q;
    q.clipboard.dangerouslyPasteHTML(value ?? '');
    q.on('text-change', () => {
      onChangeRef.current(q.root.innerHTML);
    });
  }, []);

  // Keep the editor in sync when the value is replaced externally (e.g. AI translate).
  useEffect(() => {
    const q = quillRef.current;
    if (q && value !== q.root.innerHTML) {
      q.clipboard.dangerouslyPasteHTML(value ?? '');
    }
  }, [value]);

  return (
    <div className="quill-editor">
      <div ref={holderRef} style={{ minHeight: 140 }} />
    </div>
  );
}
